/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TabBar_local = {
    readonly appTabBarVisible: boolean | null;
    readonly " $refType": "TabBar_local";
};
export type TabBar_local$data = TabBar_local;
export type TabBar_local$key = {
    readonly " $data"?: TabBar_local$data;
    readonly " $fragmentRefs": FragmentRefs<"TabBar_local">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TabBar_local",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appTabBarVisible",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'd5036b69d576fb8ccaea0c13add1d42c';
export default node;
